import gettingStarted from './getting-started.md'

export default [
  {
    title: 'Getting Started',
    path: 'getting-started',
    url: gettingStarted,
  },
]
